export default __webpack_public_path__ + "static/media/te1.41da3e07.png";